"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var FontAwesome_1 = __importDefault(require("../../../Icon/FontAwesome"));

require("./style.scss");
/**
* Pin for a `MapMarker` Component.
*/


var MapPin = function MapPin(_a) {
  var iconName = _a.iconName,
      onClick = _a.onClick,
      size = _a.size,
      style = _a.style;
  return react_1.default.createElement("div", {
    className: "story-map__pin",
    onClick: onClick,
    onKeyPress: onClick,
    role: "button",
    style: style,
    tabIndex: 0
  }, react_1.default.createElement(FontAwesome_1.default, {
    name: iconName,
    style: {
      transform: "scale(" + size / 20 + ")"
    }
  }));
};

MapPin.propTypes = {
  /** `FontAwesomeIcon` name to render */
  iconName: prop_types_1.default.string,

  /** Click handler callback used by the `MapMarker` */
  onClick: prop_types_1.default.func,

  /** Size of the `Pin` icon. */
  size: prop_types_1.default.number,

  /** Styling object of the `Pin` */
  // eslint-disable-next-line react/forbid-prop-types
  style: prop_types_1.default.object
};
MapPin.defaultProps = {
  iconName: 'FaMapMarkerAlt',
  onClick: function onClick() {},
  size: 20,
  style: {}
};
exports.default = MapPin;